import { useLanguage } from "@/lib/i18n/LanguageContext";

// Sichtbarer DE/EN-Umschalter — auf der Login-Seite UND im Hauptmenü (zwei
// Einbaustellen, weil die Login-Seite außerhalb des angemeldeten Layouts liegt).
export default function LanguageToggle({ className = "" }) {
  const { language, setLanguage } = useLanguage();

  return (
    <div
      className={`inline-flex items-center rounded-lg border border-stone-200 overflow-hidden text-xs font-medium ${className}`}
      role="group"
      aria-label="Language / Sprache"
    >
      <button
        type="button"
        onClick={() => setLanguage("de")}
        aria-pressed={language === "de"}
        className={`px-2.5 py-1 transition-colors ${
          language === "de" ? "bg-fox-fire text-white" : "bg-white text-stone-500 hover:bg-stone-50"
        }`}
      >
        DE
      </button>
      <button
        type="button"
        onClick={() => setLanguage("en")}
        aria-pressed={language === "en"}
        className={`px-2.5 py-1 transition-colors ${
          language === "en" ? "bg-fox-fire text-white" : "bg-white text-stone-500 hover:bg-stone-50"
        }`}
      >
        EN
      </button>
    </div>
  );
}
